import React from "react";
import "../components/css/fixed.css";

const FloatingWhatsApp = () => {
  return (
    <a
      href="https://wa.me/919582795505?text=Hii"
      className="floating-whatsapp"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
    >
      <div className="whatsapp-tooltip">Chat with us</div>
      <i className="fa-brands fa-whatsapp"></i>
    </a>
  );
};

export default FloatingWhatsApp;